import React, { useState } from "react";
import { Link } from "react-router-dom";
import { PHOTOVOLTAIC, REALESTATE, EMOBILITY } from "../data/data";

export default function Services() {
    const [activeTab, setActiveTab] = useState("photovoltaic");

    const servicesData = {
        photovoltaic: {
            title: "Photovoltaic Solar Energy",
            description: "Photovoltaic solar energy is a clean and renewable energy source that harnesses solar radiation to produce electricity. The sun rises daily, shining for approximately 12 hours, providing a free and abundant energy source. With proper installation, solar energy offers the freedom of cost-free electricity for up to 25 years through a one-time investment.",
            services: PHOTOVOLTAIC,
            color: "teal",
            icon: "☀️"
        },
        realestate: {
            title: "Smart & Green Real Estate",
            description: "Traditional houses are evolving into modern, internet-connected buildings that prioritize safety, convenience, and cost efficiency. With the growing need to combat greenhouse gas emissions and climate change, transitioning to green energy is essential.",
            services: REALESTATE,
            color: "green",
            icon: "🏢"
        },
        emobility: {
            title: "E-Mobility Services",
            description: "Combustion vehicles have shaped daily life for over a century but contribute significantly to climate change, emitting 1.5 billion tons of greenhouse gases annually. E-vehicles offer a cleaner alternative, reducing atmospheric pollution.",
            services: EMOBILITY,
            color: "blue",
            icon: "⚡"
        }
    };

    const colorClasses = {
        teal: {
            bg: "bg-teal-50 dark:bg-teal-900/20",
            border: "border-teal-200 dark:border-teal-800",
            text: "text-teal-600 dark:text-teal-400",
            button: "bg-teal-600 hover:bg-teal-700",
            active: "bg-teal-600 text-white"
        },
        green: {
            bg: "bg-green-50 dark:bg-green-900/20",
            border: "border-green-200 dark:border-green-800",
            text: "text-green-600 dark:text-green-400",
            button: "bg-green-600 hover:bg-green-700",
            active: "bg-green-600 text-white"
        },
        blue: {
            bg: "bg-blue-50 dark:bg-blue-900/20",
            border: "border-blue-200 dark:border-blue-800",
            text: "text-blue-600 dark:text-blue-400",
            button: "bg-blue-600 hover:bg-blue-700",
            active: "bg-blue-600 text-white"
        }
    };

    const currentService = servicesData[activeTab];
    const currentColor = colorClasses[currentService.color];

    return (
        <section 
            className="py-16 lg:py-24 relative overflow-hidden" 
            id="services"
            style={{
                backgroundColor: '#479490',
                backgroundImage: 'url("https://www.transparenttextures.com/patterns/brushed-alum.png")'
            }}
        >
            {/* Dark overlay for better text contrast */}
            <div className="absolute inset-0 bg-slate-900/20"></div>
            
            {/* Subtle gradient overlay */}
            <div className="absolute inset-0 bg-gradient-to-br from-teal-900/10 to-emerald-800/5"></div>

            <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                {/* Header Section */}
                <div className="text-center max-w-3xl mx-auto mb-16">
                    <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/90 backdrop-blur-sm rounded-full border border-white/20 mb-6">
                        <div className="w-2 h-2 bg-teal-300 rounded-full animate-pulse"></div>
                        <span className="text-sm font-medium text-teal-800">OUR SERVICES</span>
                    </div>
                    <h2 className="text-3xl lg:text-4xl font-bold text-white mb-4">
                        Sustainable Energy Solutions
                    </h2>
                    <p className="text-lg text-teal-100">
                        Comprehensive clean energy solutions for Rwanda and beyond
                    </p>
                </div>

                {/* Tab Navigation */}
                <div className="flex flex-wrap justify-center gap-3 mb-12">
                    {Object.entries(servicesData).map(([key, service]) => (
                        <button
                            key={key}
                            onClick={() => setActiveTab(key)}
                            className={`px-6 py-3 rounded-xl font-semibold transition-all duration-200 backdrop-blur-sm border ${
                                activeTab === key 
                                    ? colorClasses[service.color].active + ' shadow-lg shadow-white/20'
                                    : "bg-white/90 text-slate-700 border-white/30 hover:bg-white hover:border-white/50"
                            }`}
                        >
                            <div className="flex items-center gap-2">
                                <span className="text-lg">{service.icon}</span>
                                <span className="text-sm">{service.title.split(' - ')[0]}</span>
                            </div>
                        </button>
                    ))}
                </div>

                {/* Service Description */}
                <div className="max-w-4xl mx-auto text-center mb-12">
                    <div className="bg-white/90 backdrop-blur-sm rounded-2xl p-8 border border-white/20 shadow-lg">
                        <p className="text-slate-700 text-lg leading-relaxed">
                            {currentService.description}
                        </p>
                    </div>
                </div>

                {/* Services Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
                    {currentService.services.map((item, index) => {
                        let Icon = item.icon;
                        return (
                            <div 
                                key={index}
                                className="group relative"
                            >
                                <div className={`bg-white/95 backdrop-blur-sm rounded-2xl border border-white/30 p-6 hover:shadow-2xl hover:border-white/50 transition-all duration-300 group-hover:translate-y-[-4px] h-full flex flex-col shadow-lg`}>
                                    
                                    {/* Icon */}
                                    <div className={`inline-flex items-center justify-center w-12 h-12 rounded-xl ${currentColor.bg} ${currentColor.text} mb-4 group-hover:scale-110 transition-transform duration-300`}>
                                        <Icon className="text-xl" />
                                    </div>

                                    {/* Title */}
                                    <h3 className="text-xl font-semibold text-slate-900 mb-3">
                                        {item.title}
                                    </h3>

                                    {/* Description */}
                                    <p 
                                        className="text-slate-600 leading-relaxed mb-4 flex-grow"
                                        dangerouslySetInnerHTML={{ __html: item.desc }}
                                    />

                                    {/* Learn More Link */}
                               
                                </div>
                            </div>
                        );
                    })}
                </div>

               
              
            </div>
        </section>
    );
}